/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  Directive,
  effect,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[sharedUiIriroMouseFollowerTooltip]',
})
export class MouseFollowerTooltipDirective implements OnInit, OnDestroy {
  sharedUiIriroMouseFollowerTooltip = input<string | TemplateRef<any>>('');
  visible = input(true);
  appendTo = input<'element' | 'body' | 'window'>('element');

  visibleChanged = effect(() => {
    if (this.visible()) {
      this.createTooltip()
    } else {
      this.removeTooltip();
    }
  })

  private tooltipElement: HTMLElement | null = null;
  private viewRef: EmbeddedViewRef<any> | null = null;

  constructor(
    private host: ElementRef,
    private vcr: ViewContainerRef
  ) {}

  ngOnInit() {
    this.createTooltip()
  }

  createTooltip() {
    const tooltip = document.createElement('div');
    tooltip.classList.add('custom-tooltip');

    if (typeof this.sharedUiIriroMouseFollowerTooltip() === 'string') {
      tooltip.textContent = this.sharedUiIriroMouseFollowerTooltip() as string;
    } else if (this.sharedUiIriroMouseFollowerTooltip() instanceof TemplateRef) {
      this.viewRef = this.vcr.createEmbeddedView(this.sharedUiIriroMouseFollowerTooltip() as TemplateRef<any>);
      this.viewRef.detectChanges();
      this.viewRef.rootNodes.forEach(node => tooltip.appendChild(node));
    }

    switch (this.appendTo()) {
      case 'body':
      case 'window':
        document.body.appendChild(tooltip);
        break;
      default:
        this.host.nativeElement.appendChild(tooltip);
        break;
    }

    this.tooltipElement = tooltip;
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (!this.visible() || !this.tooltipElement) return;
    this.tooltipElement.style.top = event.clientY + 15 + 'px';
    this.tooltipElement.style.left = event.clientX + 15 + 'px';
  }

  ngOnDestroy() {
    this.removeTooltip();
  }

  private removeTooltip(): void {
    if (this.tooltipElement) {
      this.tooltipElement.remove();
      this.tooltipElement = null;
    }
    if (this.viewRef) {
      this.viewRef.destroy();
      this.viewRef = null;
    }
  }
}
